import React from 'react';
import AdvisorContentRouter from './AdvisorContentRouter';

const AdvisorContentRouterPicker = () => {
  return <AdvisorContentRouter />;
};

export default AdvisorContentRouterPicker;
